import { z } from "zod";

export const PRODUCT_SLUG_MAX_LENGTH = 120;

/** kebab-case — รองรับตัวอักษรลาว/ไทย (รวมวรรณยุกต์/สระซ้อน \p{M}) และ `--` สำหรับ slug เก่า */
export const ProductSlugSchema = z
  .string()
  .trim()
  .min(1)
  .max(PRODUCT_SLUG_MAX_LENGTH)
  .regex(
    /^[\p{L}\p{N}\p{M}]+(?:-[\p{L}\p{N}\p{M}]+)*$/u,
    "slug ຕ້ອງເປັນຕົວອັກສອນ/ເລກ ຄັ້ງດ້ວຍ -",
  );

export function slugifyProductName(name: string): string {
  return name
    .trim()
    .toLowerCase()
    .normalize("NFKC")
    .replace(/\s+/g, "-")
    .replace(/[^\p{L}\p{N}\p{M}-]+/gu, "")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "")
    .slice(0, 80);
}

export function normalizeProductSlugInput(raw: string): string {
  return raw
    .trim()
    .toLowerCase()
    .normalize("NFKC")
    .replace(/\s+/g, "-")
    .replace(/[^\p{L}\p{N}\p{M}-]+/gu, "")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "")
    .slice(0, PRODUCT_SLUG_MAX_LENGTH);
}

/** slug สำหรับ backfill / ลิงก์เก่า `friendly--productId` */
export function legacyProductSlug(name: string, productId: string): string {
  const normalized = slugifyProductName(name);
  if (!normalized) return productId;
  const suffix = `--${productId}`;
  const maxBase = PRODUCT_SLUG_MAX_LENGTH - suffix.length;
  const base =
    normalized.length > maxBase ? normalized.slice(0, maxBase) : normalized;
  return `${base}${suffix}`;
}

/** @deprecated ใช้ slug จาก DB — คงไว้สำหรับ fallback URL เก่า */
export function parseProductIdFromSlug(slug: string): string {
  const marker = "--";
  const idx = slug.lastIndexOf(marker);
  if (idx >= 0 && idx < slug.length - marker.length) {
    return slug.slice(idx + marker.length);
  }
  return slug;
}

export function toProductSlug(name: string, id: string): string {
  return legacyProductSlug(name, id);
}
